import {ReportModel} from "@fedeltapointofsale/data-client";
import {AccountSummaryReportData} from "./account-summary-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class AccountSummaryReportModel extends ReportModel<AccountSummaryReportData> {
    constructor(injector: Injector) {
        super(injector, AccountSummaryReportData);
    }
}
